<template src="./template.html"></template>

<script>
import kilopostApi from '@/api/kilopost'
import ExtremeMap2 from './ExtremeMap2'
export default {
  name: 'chisei-kiloposts',
  data() {
    return {
      origKiloposts: [],
      kiloposts: [],
    }
  },
  mounted() {
    const chiseiName = this.$route.params.chisei
    kilopostApi.getKilopostsChisei(chiseiName).then(({ data }) => {
      data.forEach(e => {
        e.kp1 = parseFloat(e.kp)
        e.kp2 = parseInt(e.kp2)
        e.kp_calc = parseFloat(e.kp_calc)
        e.lat = parseFloat(e.lat)
        e.lon = parseFloat(e.lon)
      })
      this.origKiloposts = data
      this.kiloposts = this.origKiloposts
    })
  },
  components: { ExtremeMap2 },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
